import { TWorkspaceBillingInfo, TWorkspaceBillingInfoCo, TWorkspaceBillingInfoMx } from '../../../../types/workspace-billing-info';
import {
    TWorkspacePaymentInfo, TWorkspacePaymentInfoCo, TWorkspacePaymentInfoEc, TWorkspacePaymentInfoMx,
} from '../../../../types/workspace-payment-info';
import { EWorkspaceCountry } from '../../../../types/workspaces';

const getBillingDataFromWorkspace = (workspace: any) => {
    const { billingData, payment } = workspace;

    if (!billingData && !payment) return;

    if (billingData) {
        return {
            identification: billingData?.identification,
            name: billingData?.name,
            fullAddress: billingData?.address?.fullAddress,
            email: billingData?.email,
            mobile: billingData?.mobile,
            bank: billingData?.bank,
            accountType: billingData?.accountType,
            accountNumber: billingData?.accountNumber,
            accountHolderName: billingData?.accountHolderName,
            accountIdentification: billingData?.accountIdentification,
        };
    }

    if (payment?.manager) {
        const {
            email, name, lastName, mobile, countryCode,
        } = payment?.manager;

        return {
            name: name && lastName && `${name} ${lastName}`,
            fullAddress: billingData?.address?.fullAddress,
            email,
            mobile: countryCode && mobile && `${countryCode} ${mobile}`,
        };
    }
};

const getBillingInfoFromCountry = (country: EWorkspaceCountry, billingInfo: TWorkspaceBillingInfo | null) => {
    switch (country) {
    case EWorkspaceCountry.MX: {
        const billingInfoMx = billingInfo as TWorkspaceBillingInfoMx;
        return [
            {
                key: 'rfc',
                title: 'RFC',
                content: billingInfoMx?.rfc,
            },
            {
                key: 'postalCode',
                title: 'Postal code',
                content: billingInfoMx?.postalCode,
            },
            {
                key: 'state',
                title: 'State',
                content: billingInfoMx?.state,
            },
            {
                key: 'fiscalRegime',
                title: 'Fiscal regime',
                content: billingInfoMx?.fiscalRegime,
            },
        ];
    }
    case EWorkspaceCountry.CO: {
        const billingInfoCo = billingInfo as TWorkspaceBillingInfoCo;
        return [
            {
                key: 'taxpayerType',
                title: 'Taxpayer type',
                content: billingInfoCo?.taxpayerType,
            },
            {
                key: 'city',
                title: 'City',
                content: billingInfoCo?.city,
            },
            {
                key: 'billingContactName',
                title: 'Billing contact name',
                content: billingInfoCo?.billingContactName,
            },
            {
                key: 'ivaRegime',
                title: 'IVA regime',
                content: billingInfoCo?.ivaRegime,
            },
        ];
    }
    default:
        return [];
    }
};

const getPaymentInfoFromCountry = (country: EWorkspaceCountry, paymentInfo: TWorkspacePaymentInfo | null) => {
    switch (country) {
    case EWorkspaceCountry.MX: {
        const paymentInfoMx = paymentInfo as TWorkspacePaymentInfoMx;
        return [
            {
                key: 'clabe',
                title: 'CLABE',
                content: paymentInfoMx?.clabe,
            },
        ];
    }
    case EWorkspaceCountry.CO: {
        const paymentInfoCo = paymentInfo as TWorkspacePaymentInfoCo;
        return [
            {
                key: 'clabe',
                title: 'CLABE',
                content: paymentInfoCo?.clabe,
            },
            {
                key: 'documentType',
                title: 'Document type',
                content: paymentInfoCo?.documentType,
            },
        ];
    }
    case EWorkspaceCountry.EC: {
        const paymentInfoEc = paymentInfo as TWorkspacePaymentInfoEc;
        return [
            {
                key: 'accountType',
                title: 'Account type',
                content: paymentInfoEc?.accountType,
            },
        ];
    }
    default:
        return [];
    }
};

export {
    getBillingDataFromWorkspace,
    getBillingInfoFromCountry,
    getPaymentInfoFromCountry,
};
